import { Toaster } from 'react-hot-toast';

export const NotificationsConfig = () => {
  return <Toaster position="bottom-right" />;
};
